import React from 'react';
import useResolver from '../hooks/useResolver';
import AccountStore, { SocialLoginProvider } from '../store/AccountStore';
import GithubButton from '../ui/GithubButton';
import useToast from '../hooks/useToast';

export interface ConnectedGithubLoginProps {}

const ConnectedGithubLogin: React.FC<ConnectedGithubLoginProps> = () => {
  const accountStore = useResolver(AccountStore);
  const toast = useToast();

  return (
    <GithubButton
      onClick={() =>
        accountStore.socialLogin(SocialLoginProvider.GITHUB).catch((e) =>
          toast({
            status: 'error',
            title: 'Sign in failed',
            description: e.message,
          }),
        )
      }
    />
  );
};

export default ConnectedGithubLogin;
